import { getEnv } from '../config';

export const PROTOCOL = getEnv('VITE_API_PROTOCOL', 'http');
export const HOST = getEnv('VITE_API_HOST', 'localhost');
export const PORT = getEnv('VITE_API_PORT', '8000');
export const API_PREFIX = getEnv('VITE_API_PREFIX', '/api');
export const API_ORIGIN = `${PROTOCOL}://${HOST}:${PORT}`;
export const API_BASE_URL = `${API_ORIGIN}${API_PREFIX}`;
